 let items_menus = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items_menus)
  items_menus.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });

$(document).ready(function(){
  setTimeout(function(){
$(".product-grid li.grid__item").each(function() {
    var text = '';
   $(this).find(".main-collection-variants .product-form__input input").each(function(){
       if ($(this).is(":checked"))
      {
        text += $(this).val()+" / ";
      }
   });
     var newname = text.slice(0,-2).trim();
   var get_data_sku = $(this).find(".main-collection-variants .hidden-collection-variants option[value='"+newname+"']").attr("data-sku");
    var get_data_image = $(this).find(".main-collection-variants .hidden-collection-variants option[value='"+newname+"']").attr("variant-image");
    var get_data_avail = $(this).find(".main-collection-variants .hidden-collection-variants option[value='"+newname+"']").attr("variants-avail");
    var get_data_id = $(this).find(".main-collection-variants .hidden-collection-variants option[value='"+newname+"']").attr("variant-id");
    var get_data_url = $(this).find(".main-collection-variants .hidden-collection-variants option[value='"+newname+"']").attr("variant-url");
    $(this).find(".card__information .sku_custom_html").html(get_data_sku);
    $(this).find(".card--media .card__media img").attr("src",get_data_image);
    $(this).find(".card--media .card__media img").attr("srcset",get_data_image);
    $(this).find(".card--media .card__media a").attr("href",get_data_url);
    $(this).find(".card__information a").attr("href",get_data_url);
    if(get_data_avail == 'false'){
         $(this).find(".card--media .card__badge-soldout").show();
      $(this).find(".card--media .card__badge-soldout .out_of_stock_plugin_coll").show();
      $(this).find(".card--media .card__badge-soldout .only_badges_wrapp").html("<span class='badge badge--bottom-left sold-out-badge'>Sold Out</span>");
      $(this).find(".card--media .card__badge-soldout .out_of_stock_plugin_coll").attr("data-vid",get_data_id);
      $(this).find(".card--media .card__badge-soldout .out_of_stock_plugin_coll").attr("data-sku",get_data_sku);
    }else{
     $(this).find(".card--media .card__badge-soldout").hide();
    }
  });
  },500);

  // Show popup on annocebar click
  $('#giveaway-announcebar').on('click', function () {
    $('#giveaway-popup').addClass('active');
  });

  const $popup = $("#giveaway-popup");
  function closePopup() {
      $popup.addClass("closing");

      setTimeout(() => {
          $popup.removeClass("active closing");
      }, 400);
  }

  $(".close-popup, .cancel-btn").on("click", closePopup);

  $popup.on("click", function (e) {
    if (e.target === this) {
      closePopup();
    }
  });


});
$(document).on("change",".collection  .product-grid .product-form__input--swatch input",function() {
    var text = '';
   $(this).parents(".main-collection-variants").find(".product-form__input input").each(function(){
       if ($(this).is(":checked"))
      {
        text += $(this).val()+" / ";
      }
   });
     var newname = text.slice(0,-2).trim();
   var get_data_sku = $(this).parents(".main-collection-variants").find(".hidden-collection-variants option[value='"+newname+"']").attr("data-sku");
    var get_data_image = $(this).parents(".main-collection-variants").find(".hidden-collection-variants option[value='"+newname+"']").attr("variant-image");
    var get_data_avail = $(this).parents(".main-collection-variants").find(".hidden-collection-variants option[value='"+newname+"']").attr("variants-avail");
    var get_data_id = $(this).parents(".main-collection-variants").find(".hidden-collection-variants option[value='"+newname+"']").attr("variant-id");
    var get_data_url = $(this).parents(".main-collection-variants").find(".hidden-collection-variants option[value='"+newname+"']").attr("variant-url");
    $(this).parents(".card__information").find(".sku_custom_html").html(get_data_sku);
    $(this).parents(".card--media").find(".card__media img").attr("src",get_data_image);
    $(this).parents(".card--media").find(".card__media img").attr("srcset",get_data_image);
    $(this).parents(".card--media").find(".card__media a").attr("href",get_data_url);
    $(this).parents(".card__information").find("a").attr("href",get_data_url);
    if(get_data_avail == 'true'){
$(this).parents(".card--media").find(".card__badge-soldout").hide();
    }else{
      $(this).parents(".card--media").find(".card__badge-soldout").show();
      $(this).parents(".card--media").find(".card__badge-soldout .out_of_stock_plugin_coll").show();
      $(this).parents(".card--media").find(".card__badge-soldout .only_badges_wrapp").html("<span class='badge badge--bottom-left sold-out-badge'>Sold Out</span>");
      $(this).parents(".card--media").find(".card__badge-soldout .out_of_stock_plugin_coll").attr("data-vid",get_data_id);
      $(this).parents(".card--media").find(".card__badge-soldout .out_of_stock_plugin_coll").attr("data-sku",get_data_sku);
    }
});
// 4collect:1 
        
        
       
        

